export default "__VITE_ASSET__DlAsaDsl__"